import {
  Quat,
  MultiChoiceParameter,
  Operator,
  OperatorOutputMode,
  Registry,
  XfoOperatorOutput,
} from '@zeainc/zea-engine'

/** An operator for aiming items at targets.
 * @extends Operator
 */
class RamAndPistonOperator extends Operator {
  axisParam = new MultiChoiceParameter('Axis', 0, ['+X Axis', '-X Axis', '+Y Axis', '-Y Axis', '+Z Axis', '-Z Axis'])
  ramXfoOutput = new XfoOperatorOutput('Ram', OperatorOutputMode.OP_READ_WRITE)
  pistonXfoOutput = new XfoOperatorOutput('Piston', OperatorOutputMode.OP_READ_WRITE)
  /**
   * Create a gears operator.
   * @param {string} name - The name value.
   */
  constructor(name?: string) {
    super(name)

    this.addParameter(this.axisParam)
    this.addOutput(this.ramXfoOutput)
    this.addOutput(this.pistonXfoOutput)
  }

  /**
   * The evaluate method.
   */
  evaluate(): void {
    const ramOutput = this.getOutputByIndex(0)
    const pistonOutput = this.getOutputByIndex(1)
    const ramXfo = ramOutput.getValue()
    const pistonXfo = pistonOutput.getValue()

    const axis = this.axisParam.value
    const dir = pistonXfo.tr.subtract(ramXfo.tr)
    dir.normalizeInPlace()

    const alignRam = new Quat()
    const alignPiston = new Quat()

    switch (axis) {
      case 0:
        alignRam.setFrom2Vectors(ramXfo.ori.getXaxis(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getXaxis().negate(), dir)
        break
      case 1:
        alignRam.setFrom2Vectors(ramXfo.ori.getXaxis().negate(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getXaxis(), dir)
        break
      case 2:
        alignRam.setFrom2Vectors(ramXfo.ori.getYaxis(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getYaxis().negate(), dir)
        break
      case 3:
        alignRam.setFrom2Vectors(ramXfo.ori.getYaxis().negate(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getYaxis(), dir)
        break
      case 4:
        alignRam.setFrom2Vectors(ramXfo.ori.getZaxis(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getZaxis().negate(), dir)
        break
      case 5:
        alignRam.setFrom2Vectors(ramXfo.ori.getZaxis().negate(), dir)
        alignPiston.setFrom2Vectors(pistonXfo.ori.getZaxis(), dir)
        break
    }

    ramXfo.ori = alignRam.multiply(ramXfo.ori)
    pistonXfo.ori = alignPiston.multiply(pistonXfo.ori)

    ramOutput.setClean(ramXfo)
    pistonOutput.setClean(pistonXfo)
  }
}

Registry.register('RamAndPistonOperator', RamAndPistonOperator)

export { RamAndPistonOperator }
